import { queryOptions } from "@tanstack/react-query";

import { getApiKeysView } from "./server-fns";

export function apiKeysQueryKey() {
  return ["apiKeys"] as const;
}

export function apiKeysQueryOptions() {
  return queryOptions({
    queryKey: apiKeysQueryKey(),
    queryFn: () => getApiKeysView(),
    staleTime: 30_000,
  });
}
